import { registerBlock } from '../BlockRegistry';
import HeadingBlock from './HeadingBlock';
import ParagraphBlock from './ParagraphBlock';
import ImageBlock from './ImageBlock';
import ListBlock from './ListBlock';
import TableBlock from './TableBlock';
import QuoteBlock from './QuoteBlock';
import DividerBlock from './DividerBlock';

registerBlock('heading', HeadingBlock);
registerBlock('paragraph', ParagraphBlock);
registerBlock('image', ImageBlock);
registerBlock('list', ListBlock);
registerBlock('table', TableBlock);
registerBlock('quote', QuoteBlock);
registerBlock('divider', DividerBlock);
